<template>
  <div class="container">

    <ul class="tab">
      <li class="tab-item" @click.prevent="tab = 0" :class="{active: tab === 0}">
        <a href="#">New</a>
      </li>
      <li class="tab-item" @click.prevent="tab = 1" :class="{active: tab === 1}">
        <a href="">Agreements</a>
      </li>
      <li class="tab-item" @click.prevent="tab = 2" :class="{active: tab === 2}">
        <a href="">Archived</a>
      </li>
    </ul>

    <makeagreement v-if="tab === 0" v-on:new="addAgreement"></makeagreement>

    <div v-if="tab > 0" class="dataTable">
      <div class="container">
        <div class="columns dataTableHeader">
          <div class="col-3 col-md-6">
            Name
          </div>
          <div class="col-3 col-md-5">
            Type
          </div>
          <div class="col-1 hide-md text-center">
            Sent
          </div>
          <div class="col-1 hide-md text-center">
            Accepted
          </div>
          <div class="col-1 hide-xs text-center">
            Send
          </div>
          <div class="col-1 hide-xs text-center">
            PDF
          </div>
          <div class="col-1 hide-xs text-center">
            Download
          </div>
          <div class="col-1 hide-md text-center">
            {{ tab === 1 ? 'Archive' : 'Unarchive' }}
          </div>
          <div v-if="tab === 2" class="col-1 hide-md text-center">
            Delete
          </div>
        </div>
      </div>
      <div class="columns" v-for="(a, n) in filtered">
        <div class="col-3 col-md-6">
          <button @click="viewPdf(a, 'inline')" class="btn btn-sm">{{a.corporate ? a.business : a.name}}</button>
        </div>
        <div class="col-3 col-md-5">
          <span>{{a.visatype}}</span>
        </div>
        <div class="col-1 hide-md text-center">
          <i class="icon" :class="a.sent ? 'icon-check' : 'icon-cross'"></i>
        </div>
        <div class="col-1 hide-md text-center">
          <i class="icon" :class="a.accepted ? 'icon-check' : 'icon-cross'"></i>
        </div>
        <div class="col-1 hide-xs text-center">
          <button class="btn" @click="openSendModal(a)" :class="{loading: sending === a._id}">
            <i aria-hidden="true" class="fa fa-send-o"></i>
          </button>
        </div>
        <div class="col-1 hide-xs text-center">
          <button v-if="a.pdf" class="btn btn-sm" @click="makePdf(a)" :class="{loading: makingPdf === a._id}">
            <i aria-hidden="true" class="fa fa-repeat"></i>
          </button>
        </div>
        <div class="col-1 hide-xs text-center">
          <button class="btn btn-sm" @click="viewPdf(a, 'attachment')">
            <i aria-hidden="true" class="fa fa-download"></i>
          </button>
        </div>
        <div class="col-1 hide-md text-center">
          <button class="btn" @click="archive(a)"><i aria-hidden="true" class="fa fa-file-archive-o"></i></button>
        </div>
        <div v-if="tab === 2" class="col-1 hide-md text-center">
          <button class="btn" @click="del(a)"><i aria-hidden="true" class="fa fa-trash-o"></i></button>
        </div>
      </div>

    </div>

    <sendModal :show="showSendModal"
               :agreement="toSend"
               :invoice="null"
               v-on:close="closeSendModal"></sendModal>

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import makeAgreement from '@/components/agreements/makeAgreement'
import sendAgreementModal from '@/components/agreements/sendAgreementModal'

export default {
  name: 'agreements',
  mixins: [utils],
  components: {
    'makeagreement': makeAgreement,
    'sendModal': sendAgreementModal
  },
  data () {
    return {
      tab: 0,
      sending: null, // _id of agreement being sent
      makingPdf: null, // _id of agreement being rendered as a pdf
      agreements: [],
      showSendModal: false,
      toSend: null // agreement to send
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'Cost Agreements'
    this.getAgreements()
  },
  computed: {
    filtered () {
      if (this.tab === 1) {
        return this.agreements.filter(a => { return !a.archived })
      }
      if (this.tab === 2) {
        return this.agreements.filter(a => { return a.archived })
      }
    }
  },
  methods: {
    getAgreements: function () {
      axios.get('/api/agreements/all').then(res => {
        if (res.status === 200) {
          this.agreements = res.data || []
        }
      })
    },
    del: function (a) {
      axios.post('/api/agreements/delete/' + a._id)
      .then(res => {
        if (res.status === 200) {
          let index = this.agreements.indexOf(a)
          this.agreements.splice(index, 1)
        }
      })
    },
    // Add an agreement from the making tab
    addAgreement: function (agreement) {
      this.agreements.splice(this.agreements.length, 0, agreement)
      this.agreements.sort((a, b) => { return b.name.localeCompare(a.name) })
    },
    openSendModal: function (a) {
      this.toSend = a
      this.showSendModal = true
    },
    closeSendModal: function () {
      this.showSendModal = false
    },
    archive: function (a) {
      let form = new FormData()
      form.append('id', a._id)
      form.append('flag', !a.archived)
      axios.post('/api/agreements/archive/', form)
      .then(res => {
        if (res.status === 200) {
          a.archived = !a.archived
        }
      })
    },
    makePdf: function (a) {
      this.makingPdf = a._id
      axios.post('/api/pdf/make/agreements/' + a._id)
      .then(res => {
        if (res.status === 200) {
          if (res.data) a.pdf = res.data
          this.makingPdf = null
        }
      })
      .catch(e => {
        console.log(e.response.data)
        this.makingPdf = null
      })
    },
    viewPdf: function (a, disposition) {
      // disposition must be either 'inline', for opening in a new tab,
      // or 'attachment', for a save box
      if (!a.pdf) {
        axios.post('/api/pdf/make/agreements/' + a._id)
        .then(res => {
          if (res.status === 200 && res.data) {
            a.pdf = res.data
            this.viewPdf(a, disposition)
          }
        })
      } else {
        let clientName = (a.corporate ? a.business : a.name).replace(/\s/g, '_').toLowerCase()
        let date = new Date(a.date).toLocaleDateString('en-AU', {
          year: 'numeric', month: '2-digit', day: '2-digit'
        }).replace(/\//g, '')
        let fname = ['costs_agreement', clientName, date, '.pdf'].join('_')
        let link = '/api/pdf/get/' + disposition + '/' + a.pdf + '/' + fname
        window.open(link, '_blank')
      }
    }
  }
}
</script>

<style scoped>
a {
  color: #136efb!important
  }
.btn {
  border:none;
  height: auto;
  line-height: 0;
  padding: 0;
  background:transparent;
  color:#333
}
.btn:hover {
  background:transparent
}
.btn.btn-link {
  color:#333
}
.btn.btn-sm {
  font-size:1em
}
.sm {
  font-size: .7rem;
}
.costAgreementsHeader {
  padding: 1em 0
}
.icon-check::before {
  border: 1px solid;
  border-right: 0;
  border-top: 0;
}
.icon-cross::before, .icon-minus::before, .icon-plus::before {
  height: 1px;
}
.icon-cross::after, .icon-plus::after {
  width: 1px;
}
.columns {
  padding: 0.2em;
}
.dataTable .columns:nth-child(2n) {
  background: #3fa9f526;
}
.dataTable {
  border-radius: 4px;
  padding: 1em
}
.dataTableHeader {
  background: #800080;
  color: #fff;
  padding-top: .4em;
  padding-bottom: 0.4em;
}
.dataTableHeader:hover {
  background: #800080;
}
.columns.dataTableHeader {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// agreements.vue?0b1bbcff